import { useState } from "react";
import PropTypes from "prop-types";
import { SortMobile } from "./SortMobile";
import { FilterMobile } from "./FilterMobile";
import styles from "./styles/FilterMenuMobile.module.css";

export function FilterMenuMobile({
  activeFilters,
  products,
  filterLabels,
  filteredValues,
  onChange,
  sortBy,
  setSortBy,
}) {
  const [showSort, setShowSort] = useState(false);
  const [showFilterMenu, setShowFilterMenu] = useState(false);

  const toggleSortPanel = () => setShowSort(!showSort);
  const toggleFilterPanel = () => setShowFilterMenu(!showFilterMenu);

  return (
    <div className={styles.container}>
      <button className={styles.button} onClick={toggleFilterPanel}>
        Filter +
      </button>
      <FilterMobile
        activeFilters={activeFilters}
        showFilterMenu={showFilterMenu}
        setShowFilterMenu={setShowFilterMenu}
        filterLabels={filterLabels}
        filteredValues={filteredValues}
        onChange={onChange}
      />

      <button className={styles.button} onClick={toggleSortPanel}>
        Sort +
      </button>
      <SortMobile
        productsFromCollection={products}
        filteredValues={filteredValues}
        showSort={showSort}
        setShowSort={setShowSort}
        sortBy={sortBy}
        setSortBy={setSortBy}
      />
    </div>
  );
}

FilterMenuMobile.propTypes = {
  filterLabels: PropTypes.shape({
    colour: PropTypes.objectOf(PropTypes.string),
    colourTags: PropTypes.objectOf(PropTypes.string),
    size: PropTypes.objectOf(PropTypes.string),
    type: PropTypes.objectOf(PropTypes.string),
  }),
  filteredValues: PropTypes.shape({
    colour: PropTypes.array,
    colourTags: PropTypes.array,
    size: PropTypes.array,
    type: PropTypes.array,
  }),
  onChange: PropTypes.func,
  sortBy: PropTypes.string,
  setSortBy: PropTypes.func,
  collection: PropTypes.shape({
    collectionDescription: PropTypes.string,
    handle: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.string,
  }),
  activeFilters: PropTypes.arrayOf(PropTypes.string)
};
